export default "__VITE_ASSET__CIFsyb0W__"